import numeral from 'numeral';

// load a locale
if (!numeral.locales?.fr) {
    numeral.register('locale', 'fr', {
        delimiters: {
            thousands: ' ',
            decimal: ',',
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't',
        },
        ordinal: function (number) {
            return number === 1 ? 'er' : 'ème';
        },
        currency: {
            symbol: ' €',
        },
    });
}

// switch between locales
numeral.locale('fr');

const numberUtils = {
    currencyFormatWithoutZero: nominal => `${numeral(nominal).format('0,0')} €`,
    /**
     *  @Deprecated use currencyFormat
     */
    convertToReadableCurrency: nominal => `${numeral(nominal).format('0,0.0')} €`,
    currencyFormat: nominal => {
        if (nominal < 0) {
            return `- ${numeral((nominal * -1) / 100).format('0,0.0')} €`;
        }
        return `${numeral(nominal / 100).format('0,0.0')} €`;
    },
    currencyFormatWithoutRounding: nominal => {
        if (nominal < 0) {
            return `- ${numeral((nominal * -1) / 100).format('0,0.00')} €`;
        }
        return `${numeral(nominal / 100).format('0,0.00')} €`;
    },
    currencyNumber: nominal => {
        if (nominal < 0) {
            return `- ${numeral((nominal * -1) / 100).format('0,0.0')}`;
        }
        return `${numeral(nominal / 100).format('0,0.0')}`;
    },
    currencyNumberWithoutZeroSymbol: nominal => {
        if (nominal < 0) {
            return `- ${numeral(nominal * -1).format('0,0')}`;
        }
        return `${numeral(nominal).format('0,0')}`;
    },
    endNumberWithK: number => {
        if (number >= 1000 && number < 1000000) {
            return (number / 1000).toFixed(0) + ' k€';
        }
        return number.toString();
    },
};

export default numberUtils;
